import React from 'react';
import styled from 'styled-components';
import { EllipsisOutlined } from '@ant-design/icons';
import { Popover } from 'antd';

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  .name {
    padding-right: 10px;
  }

  .names,
  .values {
    list-style: none;
    margin: 0;
    padding: 0 10px 0 0;
  }

  li {
    min-width: 1px;
    height: 20px;
    line-height: 20px;
  }

  .values {
    padding: 0;
  }
`;

const StyledIconWrapper = styled.div`
  border: 1px solid #ddd;
  border-radius: 50%;
  margin-left: 10px;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CustomEventCell = ({ cellData }) => {
  const [firstName, ...restNames] = Object.keys(cellData || {});
  const renderContent = () => {
    if (restNames.length === 0) {
      return null;
    }
    return (
      <Wrapper>
        <ul className="names">
          {restNames.map((name) => (
            <li key={name}>{name}</li>
          ))}
        </ul>
        <ul className="values">
          {restNames.map((name) => (
            <li key={`${name}_${cellData[name]}`}>{cellData[name]}</li>
          ))}
        </ul>
      </Wrapper>
    );
  };
  if (!firstName) {
    return 'None';
  }
  return (
    <Wrapper>
      <label className="name">{firstName}</label>
      <span>{cellData[firstName]}</span>
      {restNames.length > 0 && (
        <Popover content={renderContent()} destroyOnHidden>
          <StyledIconWrapper>
            <EllipsisOutlined />
          </StyledIconWrapper>
        </Popover>
      )}
    </Wrapper>
  );
};

export default CustomEventCell;
